import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '@services'

// Service registry — add new services here as their endpoints become available
const SERVICE_ENDPOINTS = {
  'learner-license': {
    baseUrl: process.env.REACT_APP_LEARNER_LICENSE_BASE_URL ?? '',
    path: '/svc/learner-license/api/v1/sync-payment-records'
  },
  'driving-license': {
    baseUrl: process.env.REACT_APP_DRIVING_LICENSE_BASE_URL ?? '',
    path: '/svc/driving-license/api/v1/sync-payment-records'
  },
  vehicle: {
    baseUrl: process.env.REACT_APP_VEHICLE_BASE_URL ?? '',
    path: '/svc/vehicle/api/v1/sync-payment-records'
  }
}

export const runSync = createAsyncThunk(
  'syncPaymentRecords/run',
  async ({ service, startDate, endDate, dryRun }, { rejectWithValue }) => {
    try {
      const endpoint = SERVICE_ENDPOINTS[service]
      const url = `${endpoint.baseUrl}${endpoint.path}`
      const response = await api.post(url, { startDate, endDate, dryRun })
      return response.data
    } catch (err) {
      const data = err.response?.data
      const msg = typeof data?.message === 'string' ? data.message : Array.isArray(data?.message) ? data.message.join(', ') : 'Request failed'
      return rejectWithValue(msg)
    }
  }
)

const syncPaymentRecordsSlice = createSlice({
  name: 'syncPaymentRecords',
  initialState: {
    result: null,
    loading: false,
    error: null
  },
  reducers: {
    clearResult(state) {
      state.result = null
      state.error = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(runSync.pending, (state) => {
        state.loading = true
        state.result = null
        state.error = null
      })
      .addCase(runSync.fulfilled, (state, action) => {
        state.loading = false
        state.result = action.payload
      })
      .addCase(runSync.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  }
})

export const { clearResult } = syncPaymentRecordsSlice.actions
export default syncPaymentRecordsSlice.reducer
